import {
    GET_PRODUCTS,
    GET_HEAVY_VEHICLE_PRODUCTS,
    GET_PRODUCT,
    GET_FILTER_OPTIONS,
    CREATE_PRODUCT,
    CREATE_BULK_PRODUCTS,
    UPDATE_PRODUCT,
    DELETE_PRODUCT
} from '../actions/product';

interface Product {
    _id: string;
    name: string;
    code: string;
    dimensions: {
        width: number;
        height: number;
        depth: number;
        unit: string;
    };
    description: string;
    images: string[];
    featuredImage: string;
    regularPrice: number;
    discountedPrice?: number;
    category: {
        _id: string;
        name: string;
    };
    isActive: boolean;
}

const initialState = {
    products: [] as Product[],
    heavyVehicleProducts: [] as Product[],
    currentProduct: null as Product | null,
    totalPages: 0,
    currentPage: 1,
    totalCount: 0,
    filterOptions: {
        brands: [],
        tireTypes: [],
        seasons: [],
        widths: [],
        aspectRatios: [],
        rimDiameters: [],
        loadIndexes: [],
        speedIndexes: [],
        priceRange: { minPrice: 0, maxPrice: 0 }
    },
    loading: false,
    error: null
};

const productReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case GET_PRODUCTS:
            return {
                ...state,
                products: action.payload.products || action.payload, // Backward compatibility
                totalPages: action.payload.totalPages || 0,
                currentPage: action.payload.currentPage || 1,
                totalCount: action.payload.totalCount || action.payload.length || 0,
                loading: false
            };
        case GET_HEAVY_VEHICLE_PRODUCTS:
            return {
                ...state,
                heavyVehicleProducts: action.payload
            };
        case GET_PRODUCT:
            return {
                ...state,
                currentProduct: action.payload,
                loading: false
            };
        case CREATE_PRODUCT:
            return {
                ...state,
                products: [...state.products, action.payload],
                loading: false
            };
        case CREATE_BULK_PRODUCTS:
            return {
                ...state,
                products: [...state.products, ...action.payload],
                loading: false
            };
        case UPDATE_PRODUCT:
            return {
                ...state,
                products: state.products.map((product) =>
                    product._id === action.payload._id ? action.payload : product
                ),
                currentProduct: state.currentProduct?._id === action.payload._id ? action.payload : state.currentProduct,
                loading: false
            };
        case DELETE_PRODUCT:
            return {
                ...state,
                products: state.products.filter((product) => product._id !== action.payload),
                loading: false
            };
        case GET_FILTER_OPTIONS:
            return {
                ...state,
                filterOptions: action.payload,
                loading: false
            };
        default:
            return state;
    }
};

export default productReducer; 